import { PrimaryReasonForIfp } from '@shared/sec-loans'
import { YesNo } from '@ui-common/types'
import { IntlShape } from 'react-intl'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getIfpInfoStepLocalizedEnums = (formatMessage: IntlShape['formatMessage']) => {
  const yesNoTexts: Record<YesNo, string> = {
    [YesNo.Yes]: formatMessage({ id: 'common-yes' }),
    [YesNo.No]: formatMessage({ id: 'common-no' }),
  }

  const primaryReasonLabels: Record<PrimaryReasonForIfp, string> = {
    [PrimaryReasonForIfp.HomeRelocation]: formatMessage({ id: 'ifp-loans-main-reason-home-relocation' }),
    [PrimaryReasonForIfp.LargerPurchases]: formatMessage({ id: 'ifp-loans-primary-reason-larger-purchases' }),
    [PrimaryReasonForIfp.PreparingForSaving]: formatMessage({ id: 'ifp-loans-primary-reason-preparing-for-saving' }),
    [PrimaryReasonForIfp.DivorceOrSeparation]: formatMessage({ id: 'ifp-loans-primary-reason-divorce-or-separation' }),
    [PrimaryReasonForIfp.Retirement]: formatMessage({ id: 'ifp-loans-primary-reason-retirement' }),
    [PrimaryReasonForIfp.Furlough]: formatMessage({ id: 'ifp-loans-primary-reason-furlough' }),
    [PrimaryReasonForIfp.LongtermIllness]: formatMessage({ id: 'ifp-loans-primary-reason-longterm-illness' }),
    [PrimaryReasonForIfp.Unemployment]: formatMessage({ id: 'ifp-loans-primary-reason-unemployment' }),
    [PrimaryReasonForIfp.AllocateFundsForOtherCredits]: formatMessage({
      id: 'ifp-loans-primary-reason-allocate-funds-for-other-credits',
    }),
    [PrimaryReasonForIfp.CompanysWeakFinancialSituation]: formatMessage({
      id: 'ifp-loans-primary-reason-companys-weak-financial-situation',
    }),
    [PrimaryReasonForIfp.ParentalLeave]: formatMessage({ id: 'ifp-loans-primary-reason-parental-leave' }),
    [PrimaryReasonForIfp.StudyLeave]: formatMessage({ id: 'ifp-loans-primary-reason-study-leave' }),
    [PrimaryReasonForIfp.Other]: formatMessage({ id: 'ifp-loans-primary-reason-other' }),
  }

  return {
    yesNoTexts,
    primaryReasonLabels,
  }
}
